import { SpreadsheetNoteData } from 'components/SpreadsheetNotes';

export const fetchSpreadsheetData = async (presignedUrl: string): Promise<SpreadsheetNoteData[]> => {
  try {
    const response = await fetch(presignedUrl);

    if (!response.ok) {
      throw new Error(`Failed to fetch spreadsheet data: ${response.statusText}`);
    }

    const jsonData = await response.json();

    const noteData  = Object.entries(jsonData).map(([key, entry]) => ({
      name: key,
      content: entry,
    }))
    // Transform the JSON data into SpreadsheetNoteData format
    return noteData as SpreadsheetNoteData[];
  } catch (error) {
    console.error('Error fetching spreadsheet data:', error);
    throw error;
  }
};